import { Injectable } from '@angular/core';
import { representanteAegente } from '../interface/representanteAgente.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { User } from 'src/app/administrador/busqueda-usuario/interfaces/user.interface';

@Injectable({
    providedIn: 'root',
})
export class RepresentanteAgenteService {
    constructor(private http: HttpClient) {}
    apiSiriUrl = environment.apiSiriUrl;

    async getRepresentanteAgente(url: string): Promise<User> {
        try {
            const apiUrl = `${this.apiSiriUrl}${url}`;
            return await firstValueFrom(this.http.get<User>(apiUrl));
        } catch (error) {
            throw error;
        }
    }
    async putRepresentanteAgente(url: string, data: representanteAegente) {
        try {
            const apiUrl = `${this.apiSiriUrl}${url}`;
            return await firstValueFrom(
                this.http.put<representanteAegente>(apiUrl, data)
            );
        } catch (error) {
            throw error;
        }
    }
}
